import { TableCell } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import Action from './Action';
import useStyles from './ActionsCell.styles';
import useCellStyles from './Cell.styles';
import { TableRowActionExact } from '../../models/tableRowAction';

const ActionsCell = ({ actions, rowValue, visible }) => {
  const cellClasses = useCellStyles();
  const classes = useStyles({ numberOfActions: actions.length });

  return (
    <TableCell className={classes.actionsCell} classes={cellClasses}>
      {visible && actions.map((action) => !rowValue.hideAction && <Action key={action.icon} action={action} rowValue={rowValue} />)}
    </TableCell>
  );
};

ActionsCell.propTypes = {
  actions: PropTypes.arrayOf(TableRowActionExact).isRequired,
  rowValue: PropTypes.shape({ hideAction: PropTypes.bool }).isRequired,
  visible: PropTypes.bool,
};

ActionsCell.defaultProps = {
  visible: false,
};

export default ActionsCell;
